// 画面の表示モード
const DISPLAY_MODE = {
  VWSSEL: "VESSEL", // 船舶単位
  CREWS: "CREWS", // 人単位
};

// スケジュールの状態
const SCHEDULING_STATUS = {
  SCHEDULED: "SCHEDULED", // 予定
  PLANNING: "PLANNING", // 計画中
};

// スケジュールイベントの種類
const SCHEDULING_EVENT_TYPE = {
  ASHORE: "ASHORE", // 陸上イベント
  DAY_OFF_REQUEST: "DAY_OFF_REQUEST", // 休暇希望
  VESSEL: "VESSEL", // 乗船中
};

// 休暇希望の優先度
const DAY_OFF_REQUEST_PRIORITY = {
  LOW: "LOW", // 低
  MEDIUM: "MEDIUM", // 中
  HIGH: "HIGH", // 高
};

// 休暇希望の優先度の名前
const DAY_OFF_REQUEST_PRIORITY_NAME = {
  HIGH: "高",
  MEDIUM: "中",
  LOW: "低",
};

// イベントレコードのアラートタイプ
const EVENT_ALERT_TYPE = {
  CAUTION: "CAUTION", // 注意
  WARNING: "WARNING", // 警戒
};

const EVENT_ALERT_INCON_COLORS = {
  CAUTION: "#FFCC00", // 注意の色
  WARNING: "#FF0000", // 警戒の色
};

// 船員アラートの種類
const ENTERPRISE_CREW_ALERT_KIND = {
  REPLACEMENT_CREW_NOT_ASSIGNED: "REPLACEMENT_CREW_NOT_ASSIGNED", //入替船員未登録アラート
};

/*
 * 航行区域の名前
 * COAST: 沿海, INLAND: 平水, NEAR: 近海, OCEAN: 遠洋, RESTRICTED_NEAR: 限定近海
 * 航行区域の名前を定義
 */
const VESSEL_NAVIGATION_AREA_NAME = {
  COAST: "沿海",
  INLAND: "平水",
  NEAR: "近海",
  OCEAN: "遠洋",
  RESTRICTED_NEAR: "限定近海",
};

/**
 * 航行時間
 */
const VESSEL_NAVIGATION_TIME_NAME = {
  UNDER_8: "8時間以内",
  UNDER_12: "8時間超～12時間以内",
  UNDER_16: "12時間超～16時間以内",
  OVER_16: "16時間超",
};

export default {
  DISPLAY_MODE,
  SCHEDULING_STATUS,
  SCHEDULING_EVENT_TYPE,
  DAY_OFF_REQUEST_PRIORITY,
  DAY_OFF_REQUEST_PRIORITY_NAME,
  EVENT_ALERT_TYPE,
  EVENT_ALERT_INCON_COLORS,
  ENTERPRISE_CREW_ALERT_KIND,
  VESSEL_NAVIGATION_AREA_NAME,
  VESSEL_NAVIGATION_TIME_NAME,
};
